export default __webpack_public_path__ + "static/RootSans-11Black-8d296c8fcf730d5f842e7f2c0cd394db.woff";